import { useEffect } from 'react';
import { CoreEvents } from '@fanduel/cpe-um-bundle/core-events/library';
import { isNativeRealityCheckEnabled } from '@/unified-modules/rg/native-reality-check';
import {
  isRealityCheckDismissedEvent,
  isRealityCheckShownEvent,
} from '@/unified-modules/rg/reality-check-events';
import {
  dequeueRealityCheckAutoplayGuard,
  queueRealityCheckAutoplayGuard,
} from '@/unified-modules/rg/reality-check-queue';

const RC_EVENT_NAME = 'RealityCheck';

/**
 * Mirrors CPE Reality Check modal lifecycle into the popup queue so autoplay
 * stops while RC is visible. The queue entry is a sentinel only — RG UM draws
 * the modal UI.
 */
export const useRealityCheckAutoplayGuard = () => {
  useEffect(() => {
    if (isNativeRealityCheckEnabled()) {
      return;
    }

    const unsubscribe = CoreEvents?.subscribe?.((event) => {
      if (event?.name !== RC_EVENT_NAME) {
        return;
      }

      if (isRealityCheckShownEvent(event.data)) {
        queueRealityCheckAutoplayGuard();
      } else if (isRealityCheckDismissedEvent(event.data)) {
        dequeueRealityCheckAutoplayGuard();
      }
    });

    return () => {
      unsubscribe?.();
    };
  }, []);
};
